import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
const ButtonModifier = {
    contained: (theme, color, disabled) => css `
    background: ${disabled
        ? '#DFDFDF'
        : color === 'primary'
            ? theme.color.brand.primary.nth1
            : theme.color.brand.tertiary.nth1};
    color: ${disabled
        ? '#808080'
        : color === 'primary'
            ? theme.color.neutral.nth4
            : 'white'};
  `,
    outlined: (theme, color) => css `
    background: none;
    border: 1px solid
      ${color === 'primary'
        ? theme.color.brand.primary.nth1
        : theme.color.brand.tertiary.nth1};
    color: ${color === 'primary'
        ? theme.color.brand.primary.nth1
        : theme.color.brand.tertiary.nth1};
  `,
    text: (theme, color) => css `
    background: none;
    border: none;
    color: ${color === 'primary'
        ? theme.color.brand.primary.nth1
        : theme.color.brand.tertiary.nth1};
  `,
    giant: (theme) => css `
    padding: ${theme.spacing.stack.xxxs} ${theme.spacing.inline.xxs};
    border-radius: ${theme.border.radius.large};
  `,
    large: (theme) => css `
    padding: ${theme.spacing.inline.xxxs} ${theme.spacing.inline.xxs};
    border-radius: ${theme.spacing.inline.small};
  `,
    medium: (theme) => css `
    padding: ${theme.spacing.inline.small} ${theme.spacing.inline.xxs};
    border-radius: ${theme.border.radius.medium};
  `,
    small: (theme) => css `
    padding: ${theme.spacing.inline.small} ${theme.spacing.inline.xxs};
    border-radius: ${theme.spacing.inline.small};
    font-size: ${theme.spacing.inline.xxxs};
  `
};
export const Container = styled(motion.button) `
  ${({ theme, variant, color, size, fullWidth, disabled }) => css `
    cursor: pointer;
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.bold};
    outline: 0;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    ${ButtonModifier[variant](theme, color, disabled)};
    ${ButtonModifier[size](theme)};
    width: ${fullWidth ? '100%' : 'auto'};
  `}
`;
//# sourceMappingURL=Button.styles.js.map